// Bank accounts for manual transfer — displayed at Step 4 & payment upload panel
export const BANK_ACCOUNTS = [
  { bank: "BSI (Bank Syariah Indonesia)", number: "7211 4291 41", name: "PT Baitullah Tiga Kharisma" },
  { bank: "BNI Syariah",                   number: "1234 5678 90", name: "PT Baitullah Tiga Kharisma" },
];

export const ROOM_TYPES = [
  { key: "quad",   label_id: "Quad (4 orang)",   label_en: "Quad (4 pax)",   addIdr: 0 },
  { key: "triple", label_id: "Triple (3 orang)", label_en: "Triple (3 pax)", addIdr: 3_000_000 },
  { key: "double", label_id: "Double (2 orang)", label_en: "Double (2 pax)", addIdr: 6_000_000 },
];

export const PAYMENT_METHODS = [
  {
    key: "transfer_manual",
    label_id: "Transfer Manual (Bayar Penuh)",
    label_en: "Manual Transfer (Full Payment)",
    desc_id: "Bayar total DP + pelunasan via transfer. Unggah bukti transfer di portal setelah pendaftaran.",
    desc_en: "Pay total DP + settlement via transfer. Upload proof in portal after registration.",
  },
];

export const UNIFORM_SIZES = ["S", "M", "L", "XL", "XXL", "XXXL"];

export const RELATIONS = [
  { v: "suami",   l: "Suami" },
  { v: "istri",   l: "Istri" },
  { v: "ayah",    l: "Ayah" },
  { v: "ibu",     l: "Ibu" },
  { v: "anak",    l: "Anak" },
  { v: "saudara", l: "Saudara Kandung" },
  { v: "paman",   l: "Paman" },
  { v: "bibi",    l: "Bibi" },
  { v: "lainnya", l: "Lainnya" },
];
